module.exports = __webpack_public_path__ + "static/media/brain05609fbf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/brain.svg
// module id = 1319
// module chunks = 0